import type { TCtaPlacement } from '../models/cta'
import type { TLayout } from '../models/playlist'

export function ctaPlacementToPercentStyle(
  placement: TCtaPlacement,
  layout: TLayout
): Record<string, string> {
  const { width: maxWidth, height: maxHeight } = layout
  const left = `${(placement.x0 / maxWidth) * 100}%`
  const top = `${(placement.y0 / maxHeight) * 100}%`
  const width = `${(placement.width / maxWidth) * 100}%`
  const height = `${(placement.height / maxHeight) * 100}%`
  return {
    position: 'absolute',
    left,
    top,
    width,
    height,
    boxSizing: 'border-box'
  }
}

export function defaultCtaPlacement(ctaId: string, layout: TLayout): TCtaPlacement {
  const size = Math.max(48, Math.round(layout.width * 0.14))
  const box = Math.min(size, layout.width, layout.height)
  const margin = Math.round(layout.width * 0.02)
  return {
    id: crypto.randomUUID(),
    ctaId,
    x0: Math.max(0, layout.width - box - margin),
    y0: Math.max(0, layout.height - box - margin),
    width: box,
    height: box
  }
}

/** Clamps placement to layout bounds; CTA overlays are always square. */
export function clampPlacementToLayout(placement: TCtaPlacement, layout: TLayout): TCtaPlacement {
  const minSize = 32
  let { x0, y0 } = placement
  let size = Math.max(placement.width, placement.height)
  size = Math.max(minSize, Math.min(size, layout.width, layout.height))
  x0 = Math.max(0, Math.min(x0, layout.width - size))
  y0 = Math.max(0, Math.min(y0, layout.height - size))
  size = Math.min(size, layout.width - x0, layout.height - y0)
  size = Math.max(minSize, size)
  return { ...placement, x0, y0, width: size, height: size }
}
